/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { InputField } from '../../../../../Components/FormFields/InputField';
import IbanField from '../../../../../Components/FormFields/IbanField';
import { CheckboxField } from '../../../../../Components/FormFields/CheckboxField';

/**
 * DirectDebitTabPanel Component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function DirectDebitTabPanel(props) {
  const {
    value, index, iban, accountOwner, validateField, paymentTerms, ...other
  } = props;

  const {
    values: { paymentChoice },
  } = useFormikContext();

  const renderFormFields = () => {
    if (paymentChoice !== 'DIRECT_DEBIT') {
      return null;
    }

    return (
      <Grid container spacing={2}>
        <Grid key={accountOwner.label} item xs={12} md={12}>
          <InputField name={accountOwner.name} label={accountOwner.label} fullWidth required />
        </Grid>
        <Grid key={iban.name} item xs={12}>
          <IbanField name={iban.name} label={iban.label} validateField={validateField} required fullWidth />
        </Grid>
        <Grid item xs={12}>
          <CheckboxField name={paymentTerms.name} label={paymentTerms.label} fullWidth required />
        </Grid>
      </Grid>
    );
  };

  return (
    <Box
      paddingTop={4}
      role="tabpanel"
      hidden={value !== index}
      id={`payment-tabpanel-${index}`}
      aria-labelledby={`payment-tab-${index}`}
      {...other}
    >
      {renderFormFields()}
    </Box>
  );
}

DirectDebitTabPanel.propTypes = {
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  accountOwner: PropTypes.object.isRequired,
  iban: PropTypes.object.isRequired,
  validateField: PropTypes.func.isRequired,
  paymentTerms: PropTypes.object.isRequired,
};
